import React from "react"
import { DeviceEventEmitter } from "~/ui/primitives"
import ImageGallery from "~pages/app-stack/image-gallery/image-gallery-screen"
import type { ImageGalleryProps } from "~pages/app-stack/image-gallery/types"
import type { PopupContextType } from "~components/Popup/types"
import { popupBridge } from "~components/Popup/popup-bridge"
import { OPEN_IMAGE_GALLERY } from "~components/Popup/popup-events"

let activeGalleryPopupId: number | null = null

export function openImageGalleryWithApi(params: ImageGalleryProps, popup: PopupContextType) {
  if (activeGalleryPopupId != null) {
    popup.close(activeGalleryPopupId)
    activeGalleryPopupId = null
  }

  let popupPromise: ReturnType<typeof popup.open> | undefined
  popupPromise = popup.open({
    type: "fullscreen",
    transparent: true,
    disableBackdropClose: true,
    content: () =>
      React.createElement(ImageGallery, {
        ...params,
        popupId: popupPromise!.id,
        onClose: () => {
          if (popupPromise) popup.close(popupPromise.id)
        },
      }),
  })

  activeGalleryPopupId = popupPromise.id
  void popupPromise.then(() => {
    if (activeGalleryPopupId === popupPromise!.id) {
      activeGalleryPopupId = null
    }
  })

  return popupPromise.id
}

/** 全局单例图片/视频预览弹窗，避免路由跳转导致聊天页重渲染 */
export function openImageGallery(params: ImageGalleryProps) {
  const popup = popupBridge.get()
  if (popup) {
    return openImageGalleryWithApi(params, popup)
  }

  DeviceEventEmitter.emit(OPEN_IMAGE_GALLERY, params)
  return null
}

export function closeImageGallery() {
  const popup = popupBridge.get()
  if (!popup || activeGalleryPopupId == null) return
  popup.close(activeGalleryPopupId)
  activeGalleryPopupId = null
}
